import { service } from '@ember/service';
import Route from '@ember/routing/route';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type PartnerService from 'tio-employee/services/partner';
import type SessionContextService from 'tio-employee/services/session-context';
import type EmployeeModel from 'tio-data/models/employee';

export default class AuthenticatedCollegePlanningMentorsRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;
  @service declare partner: PartnerService;
  queryParams = {
    phoneScheduler: {
      refreshModel: true, // reload model when this param changes
    },
  };
  async model(params: { phoneScheduler?: string }) {
    // @ts-expect-error: fix model types
    const employee = await this.store.findRecord<EmployeeModel>(
      'employee',
      this.sessionContext.currentEmployee.id
    );

    return { employee: employee, phoneScheduler: params.phoneScheduler };
  }
}
